import sliceCreator from '../../index.jsx';
import {CREATE_DEALER} from '../../../constants/index.jsx';
const _createDealerAction = sliceCreator('CREATE_DEALER', CREATE_DEALER, 'post');

const { asyncAction: createDealerAction, reducer, clearData: clearCreateDealerAction } = _createDealerAction;

export default reducer;

export {
    createDealerAction,
    clearCreateDealerAction
}